import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './notify-cancellation-emails.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const NotifyCancellationEmailsDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const notifyCancellationEmailsEntity = useAppSelector(state => state.notifyCancellationEmails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="notifyCancellationEmailsDetailsHeading">
          <Translate contentKey="comexApp.notifyCancellationEmails.detail.title">NotifyCancellationEmails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{notifyCancellationEmailsEntity.id}</dd>
          <dt>
            <span id="emailAddress">
              <Translate contentKey="comexApp.notifyCancellationEmails.emailAddress">Email Address</Translate>
            </span>
          </dt>
          <dd>{notifyCancellationEmailsEntity.emailAddress}</dd>
        </dl>
        <Button tag={Link} to="/notify-cancellation-emails" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/notify-cancellation-emails/${notifyCancellationEmailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NotifyCancellationEmailsDetail;
